import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { exchangeSsoToken } from '../../actions/loginAndRegisterActions';
import ErrorResponse from '../../components/ErrorResponse';
import spinner from '../../components/Spinner';
import ViewWrapper from '../../components/ViewWrapper';
import logo from '../../img/Airthings_Favicon.png';
import { ErrorType } from '../../models/commonModels';
import { Store } from '../../reducers';
import { RequestType } from '../../reducers/requestReducer';
import { useQuery } from '../LoginViews/LoginView';
import styles from './ValidationPage.module.scss';

type Props = {
    loading: boolean;
    error?: ErrorType;
};
const ValidationPage = ({ loading, error }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const query = useQuery();

    const [authorizationErrorMessage, setAuthorizationErrorMessage] = useState('');

    const tokenExchange = (): void => {
        if (query.get('error')) {
            setAuthorizationErrorMessage(query.get('error_description'));
        } else {
            dispatch(exchangeSsoToken());
        }
    };

    useEffect((): void => {
        if (error) setAuthorizationErrorMessage(`ErrorCodes.${error.error}`);
    }, [error]);

    useEffect(() => {
        tokenExchange();
    }, []);

    return (
        <ViewWrapper>
            <div className={styles.content}>
                <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />

                {authorizationErrorMessage ? (
                    <div className={styles.text}>
                        <ErrorResponse error={authorizationErrorMessage} testAttr={'sso-authorization-error'} />
                    </div>
                ) : (
                    loading && (
                        <div className={styles.text}>
                            {spinner}
                            <p>{txt('SingleSignOn.SigningIn')}</p>
                        </div>
                    )
                )}
            </div>
        </ViewWrapper>
    );
};

const mapStateToProps = (state: Store): Props => {
    const {
        requests: {
            [RequestType.ExchangeSsoToken]: { loading, error },
            [RequestType.RegisterConsent]: { error: authorizationError },
        },
    } = state;

    return {
        loading,
        error: error || authorizationError,
    };
};

export default connect(mapStateToProps)(ValidationPage);
